export const INTAKE_Q = {
  ACCOUNT_ID: process.env.INTAKE_Q_ACCOUNT_ID || 'account-id-not-set',
  MODE: process.env.INTAKE_Q_MODE || 'test',
};

export const isIntakeQProduction = () => {
  return INTAKE_Q.MODE === 'production';
};
